import {URLS, ck} from 'fire-wind-water';
ck.json = true;
class ShareUrl {
    constructor() {
    }

    getUrlSearchParam(url) {
        url = url || window.location.href;
        // '?' 号后面接的是索引参数，如果找到则+1，去除'?' 号
        if(url.indexOf('?') == -1){
            return null;
        }
        var search = url.substring(url.indexOf('?') + 1);
        // 把搜索参数字符串提过URLSearchParams转成对象形式
        var usp = new URLSearchParams(search);
        // 通过URLSearchParams自带的get方法，查询键所对应的值
        return usp;
    }

    //如果有来源渠道时，分享链接需要拼上渠道参数
    addChannelParamByUrl(url) {
        //如果跳转短链接时，不拼接参数,如果是全员营销链接，不拼接渠道参数
        if (url.indexOf('uao.so') !== -1) {
            return url;
        }
        var locationUrl = window.location.href;
        if (locationUrl.indexOf('h5fission/index.html') !== -1) {
            return url;
        }
        var returnUrl = '';
        var backUrl = '';
        var nurl = new URL(url);
        var queryString = url.substring(0, url.indexOf('?'));
        var hash = nurl.hash;
        var params = this.getUrlSearchParam(url);
        if(!params){
            return url;
        }
        //判断链接是否带授权,带参数的话，需要拼到跳转URL上
        if (params.has('return_url')) {
            returnUrl = url.split('&return_url=');
            var rurl = decodeURIComponent(returnUrl[1]);
            var returnParams = this.getUrlSearchParam(rurl.substring(0, rurl.indexOf('#')));
            returnParams = this.addChannelParams(returnParams);
            var rqueryString = rurl.substring(0, rurl.indexOf('?'));
            var rhash = rurl.indexOf('#') !== -1 ? rurl.substring(rurl.indexOf('#') + 1) : '';
            //URL里带back_returnUrl参数的链接处理,把来源渠道参数去掉
            if (returnParams.has('back_returnUrl')) {
                var burl = returnParams.get('back_returnUrl');
                burl = decodeURIComponent(burl);
                var bqueryString = burl.substring(0, burl.indexOf('?'));
                var bhash = burl.indexOf('#') !== -1 ? burl.substring(burl.indexOf('#') + 1) : '';
                var backParams = this.getUrlSearchParam(burl.substring(0, burl.indexOf('#')));
                backParams = this.delChannelParams(backParams);
                backUrl = this.mergeUrl(bqueryString, backParams, bhash);
                returnParams.set('back_returnUrl', encodeURIComponent(backUrl));
            }
            //分享链接处理，把back_returnUrl去掉
            returnParams.delete('back_returnUrl');
            params.delete('back_returnUrl');
            returnUrl = this.mergeUrl(rqueryString, returnParams, rhash);
            params.set('return_url', returnUrl);
        }else{
            if (params.has('back_returnUrl')) {
                backUrl = url.split('&back_returnUrl=');
                var burl = decodeURIComponent(backUrl[1]);
                var bqueryString = burl.substring(0, burl.indexOf('?'));
                var bhash = burl.indexOf('#') !== -1 ? burl.substring(burl.indexOf('#') + 1) :'';
                var backParams = this.getUrlSearchParam(burl.substring(0, burl.indexOf('#')));
                backParams = this.delChannelParams(backParams);
                backUrl = this.mergeUrl(bqueryString, backParams, bhash);
                params.set('back_returnUrl', backUrl);
            }
            params.delete('back_returnUrl');
            params = this.addChannelParams(params);
        }
        if(params) {
          url = this.mergeUrl(queryString, params, hash);
        }
        return url;
    }

    mergeUrl(queryString, param, hash) {
        var newUrl = queryString + '?' + param.toString();
        if (hash != '' && hash != null && hash != undefined) {
            hash = hash.indexOf('#') !== -1 ? hash.substring(hash.indexOf('#') + 1) : hash;
            newUrl = newUrl + '#' + hash;
        }
        return newUrl;
    }

    addChannelParams(data){
        //增加来源渠道参数，
        let fields = ['firstModuleId', 'firstTenantId', 'firstInstanceId', 'firstObjModuleId', 'firstObjId', 'firstProgramId', 'firstObjectTitle'];
        let channelList = ck.cookie();
        for (let item in channelList){
            if (item.indexOf('channel_') !== -1) {
                let tempk = item.replace('channel_', '');
                if (fields.indexOf(tempk) !== -1) {
                    continue;
                }
                if (!data.has(tempk) && channelList[item] != '' && channelList[item] != null && channelList[item] != undefined && channelList[item] != 'undefined') {
                    data.append(tempk, channelList[item]);
                }
            }
        }
        return data;
    }

    delChannelParams(data){
        //增加来源渠道参数，
        let channelList = ck.cookie();
        for (let item in channelList){
            if (item.indexOf('channel_') !== -1) {
                let tempk = item.replace('channel_', '');
                data.delete(tempk);
            }
        }
        return data;
    }
}

export const shareUrl = new ShareUrl();
